export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-2 bg-accent-500/10 rounded-2xl blur-lg"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20modern%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20movie%20streaming%20interface%2C%20cozy%20ambient%20lighting%2C%20soft%20coral%20and%20amber%20tones%2C%20comfortable%20viewing%20environment%2C%20cinematic%20atmosphere%2C%20clean%20organized%20space%2C%20no%20visible%20brand%20logos%20or%20text%20on%20screen&width=800&height=550&seq=about-nc-01&orientation=landscape"
                alt="嫩草视频高清流畅观影体验场景"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '16/10' }}
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              关于嫩草视频
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed font-label">
              嫩草视频是一个专注于手机网页版高清影视观影的聚合平台。我们整合了<strong className="text-foreground-900 font-semibold">97视频</strong>、<strong className="text-foreground-900 font-semibold">丝瓜视频</strong>、<strong className="text-foreground-900 font-semibold">蓝莓视频</strong>以及<strong className="text-foreground-900 font-semibold">91在线视频</strong>等热门资源渠道，为用户提供电影、电视剧、综艺、动漫等丰富的影视内容。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed font-label">
              无需下载APP，打开手机浏览器即可高清流畅观影。我们持续优化播放体验，确保<strong className="text-foreground-900 font-semibold">不卡顿</strong>、<strong className="text-foreground-900 font-semibold">加载快</strong>，让您在碎片时间也能享受沉浸式的观影乐趣。每日更新热门影片，追剧不掉队，看片不等待。
            </p>

            <div className="grid grid-cols-3 gap-4 mt-7">
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="font-heading font-bold text-xl md:text-2xl text-primary-600">10万+</div>
                <div className="text-xs text-foreground-500 font-label mt-1">影视资源</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="font-heading font-bold text-xl md:text-2xl text-accent-600">99.9%</div>
                <div className="text-xs text-foreground-500 font-label mt-1">播放流畅率</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                <div className="font-heading font-bold text-xl md:text-2xl text-primary-600">免APP</div>
                <div className="text-xs text-foreground-500 font-label mt-1">即开即看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}